import {SortEnum} from '@/__generated__/__types__';
import {filterAttributeCodeValueType} from '@/framework/static/filter-attribute-code-value-type';
import {ProductQueryParams} from '@/lib/constants';
import {isArray} from 'lodash';
import {type ReadonlyURLSearchParams} from 'next/navigation';

export const getFilterOptionsBySearchParams = (
    searchParams: ReadonlyURLSearchParams,
    defaultValue: Record<string, any> = {},
): Record<string, any> => {
    const filterOptions: Record<string, any> = {...defaultValue};

    for (const [key, values] of searchParams.entries()) {
        if (filterAttributeCodeValueType.filterMatchType.includes(key)) {
            filterOptions[key] = filterAttributeCodeValueType.getFilterMatchTypeValue(values as string);
        } else if (filterAttributeCodeValueType.filterEqualType.includes(key)) {
            const valuesArray = (values as string).split(',');
            filterOptions[key] = filterAttributeCodeValueType.getFilterEqualTypeValue(valuesArray);
        } else if (filterAttributeCodeValueType.filterRangeType.includes(key)) {
            const valuesArray = (values as string).split('-');
            filterOptions[key] = filterAttributeCodeValueType.getFilterRangeTypeValue(valuesArray);
        }
    }

    return filterOptions;
};

export const getCommonQueryParams = (searchParams: ReadonlyURLSearchParams) => {
    const initialPage = Number.parseInt(searchParams.get(ProductQueryParams.PAGINATION) ?? '1');

    const initialSortValue = searchParams.get(ProductQueryParams.SORTING);
    const initialSortDirection = searchParams.get(ProductQueryParams.DIRECTION);
    const initialSort = initialSortValue ? {[initialSortValue]: initialSortDirection} : {new_product: SortEnum.Asc};

    const searchQueryParam = searchParams.get(ProductQueryParams.SEARCH);
    const initialSearchValue = isArray(searchQueryParam)
        ? (searchQueryParam.join(' ') ?? '')
        : (searchQueryParam ?? '');
    const initialSearch = initialSearchValue;

    return {
        page: initialPage,
        sort: initialSort,
        search: initialSearch,
    };
};
